import React, { Component, dangerouslySetInnerHTML } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import './QnaStyle.css';
import { Container, Col, Row, Card, Accordion, Table } from 'react-bootstrap'
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel'
import ClipLoader from "react-spinners/ClipLoader";
import Modal from 'react-modal'
import axios from 'axios';
import moment from 'moment';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import firebase from 'lib/firebase';
import api from 'lib/api';
import global from 'lib/global';
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';
import HeaderWrite from '../Components/HeaderWrite';

import * as UserActions from 'store/modules/UserModule';


class QnaPostScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userInfo: {},
            postType: this.props.history.location.state.postType, //0: 새 글 , 1: 답변글 
            qnaData: this.props.history.location.state.data, // null: 새 글 쓰기, 데이터 있음: 수정하기

            // 글 내용
            contentsTitle: "",
            contentsText: ""
        }
    }

    componentDidMount() {
        const self = this;

        firebase.auth().onAuthStateChanged(async function (user) {
            let userData = await self.props.userActions.getUserInfo();
            if (userData.data.result) {
                self.setState({ userInfo: userData.data.data });
            }
        });

        if (this.state.qnaData != null) {
            this.setState({
                contentsTitle: this.state.qnaData.title,
                contentsText: this.state.qnaData.contents,
            })

            if (this.state.postType != undefined) {
                this.setState({
                    contentsTitle: "[Re] " + this.state.qnaData.title,
                    contentsText: "\n\n-------- original --------\n" + this.state.qnaData.contents,
                })
            }
        }
    }

    onClickBack = () => {
        console.log("목록으로 돌아가기")
        this.props.history.goBack();
    }

    onChangeContentsTitle = (e) => {
        this.setState({ contentsTitle: e.target.value })
    }

    onChangeContentsText = (event, editor) => {
        // this.setState({ contentsText: e.target.value })
        const changeText = editor.getData();
        this.setState({ contentsText: changeText })
    }


    onClickPost = () => {
        const self = this;

        if (this.state.qnaData == null) {
            console.log("새 글")

            if (this.state.contentsTitle == "") {
                alert("please input title")
            } else if (this.state.contentsText == "") {
                alert("plase input text")
            } else {
                api.post('/workbook/qna/add', { userIdx: this.state.userInfo.idx, qnaTitle: this.state.contentsTitle, qnaText: this.state.contentsText })
                    .then(function (result) {
                        if (result) {
                            alert("complete")
                            console.log(result)
                            self.props.history.push(`/qna`)
                        }
                    })
                    .catch(err => {
                        console.log("err", err)
                    })
            }
        } else if (this.state.qnaData != null && this.state.postType > 0) {
            console.log("답글쓰기")

            if (this.state.contentsTitle == "") {
                alert("please input title")
            } else if (this.state.contentsText == "") {
                alert("plase input text")
            } else {
                api.post('/workbook/qna/answer', { userIdx: this.state.userInfo.idx, qnaIdx: this.state.qnaData.idx, qnaTitle: this.state.contentsTitle, qnaText: this.state.contentsText })
                    .then(function (result) {
                        if (result) {
                            alert("complete")
                            console.log(result)
                            self.props.history.push(`/qna`)
                        }
                    })
                    .catch(err => {
                        console.log("err", err)
                    })
            }

        } else if (this.state.qnaData != null) {
            console.log("수정")

            if (this.state.contentsTitle != this.state.qnaData.title || this.state.contentsText != this.state.qnaData.contents) {
                api.post('/workbook/qna/edit', { qnaIdx: this.state.qnaData.idx, qnaTitle: this.state.contentsTitle, qnaText: this.state.contentsText })
                    .then(function (result) {
                        if (result) {
                            console.log("edit ok", result)
                            let data = result.data.data;
                            let idx = data.idx;

                            self.props.history.push({ pathname: `/qna/${idx}`, state: { data: data } });
                            // self.props.onChangeBoardType({ boardType: 1, editType: false, data: data });
                            // self.props.history.goBack();
                        }
                    })
                    .catch(err => {
                        console.log("err", err)
                    })
            }
        }
    }


    render() {

        return (
            <div id="qna_read">
                <form>
                    <div>Title:</div>
                    <input type="text" maxLength={50} value={this.state.contentsTitle} onChange={this.onChangeContentsTitle} />

                    <div>Contents:</div>
                    <textarea value={this.state.contentsText} onChange={this.onChangeContentsText} maxLength={15000} style={{ height: 130, width: 500 }} />
                </form>

                <CKEditor
                    editor={ClassicEditor}
                    // data={this.state.contentsText}
                    onReady={editor => { editor.setData(this.state.contentsText) }}
                    onChange={(event, editor) => this.onChangeContentsText(event, editor)}
                // onBlur={(event, editor) => {
                //     console.log('Blur.', editor);
                // }}
                // onFocus={(event, editor) => {
                //     console.log('Focus.', editor);
                // }}
                />

                <Container>
                    <Row>
                        <Col><div onClick={this.onClickBack} style={{ backgroundColor: 'orange' }}>Back</div></Col>
                        <Col></Col>
                        <Col><div onClick={this.onClickPost} style={{ backgroundColor: 'orange' }}>Post</div></Col>
                        <Col></Col>
                        <Col>
                            <Link to={'/qna'}>
                                <div style={{ backgroundColor: 'orange' }}>List</div>
                            </Link>
                        </Col>
                    </Row>
                </Container >
            </div >
        )
    }
}


let mapStateToProps = (state) => ({
    // userInfo: JSON.parse(JSON.stringify(state.UserModule.get('userInfo'))),
});

let mapDispatchToProps = (dispatch) => ({
    userActions: bindActionCreators(UserActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(QnaPostScreen);